import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CallbackType, FocusInputType, InteractionType, KeyValues5, LocalService, PaidType, Payment, PaymentGatewayOrderStatus, PaymentGatewayServiceType, Status } from '../../../service/local.service';
import { WindowRefService } from '../../../service/window-ref.service';
import { PaymentManagementService } from 'src/service/payment-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { environment } from 'src/environments/environment';
import { WsUserService } from 'src/service/ws/ws-user.service';
import { EmitResponse } from 'src/service/ws/wsSupporting/wsEntities';
import { EmitType, RegisterName } from 'src/service/ws/wsSupporting/wsTypes';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
  providers: [WindowRefService]
})
export class PaymentsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["payments"];
  InteractionType = InteractionType;

  @Input() isShowPayment: boolean = false;
  @Input() paidType: PaidType; @Input() businessOrUserId = ''; @Input() amount: number = null; @Input() interactionType: InteractionType;
  @Input() notes: string = 'From PnixSoft'; @Input() ids?: string[]; @Input() datas?: KeyValues5[]; @Input() supportingId: string;
  @Input() isShowTestCallBack: boolean = true;

  @Output() isShowPaymentChange = new EventEmitter();
  @Output() onPaymentProccesed = new EventEmitter();

  @Input() currency = '';
  logoUrl: string = './../../../../assets/icons/favicon32.png';
  name: string = '';
  paymentHandler: any = null;
  paymentGatewayServiceType: PaymentGatewayServiceType = PaymentGatewayServiceType.RandomOrNone;
  payment: Payment;

  razorpayWindow: any;

  isPaymentLinkPopupOpen = false;
  encRequest: string;
  accessCode: string;
  action: string;
  orderId = '';
  processId: string = '';

  isShowGooglePayment: boolean = false;
  googlePaymenyEnvironment: any;
  buttonColor = "black";
  buttonType = "buy";
  isCustomSize = false;
  buttonWidth = 240;
  buttonHeight = 40;
  isTop = window === window.top;
  googlePaymentRequest: google.payments.api.PaymentDataRequest;

  customerDetails: KeyValues5 = {} as KeyValues5;
  isPaymentLink: boolean = false; paymentLinkUrl: string = '';

  htmlId: string = ''; elementIds: any;

  constructor(private winRef: WindowRefService, public localService: LocalService, private paymentManagementService: PaymentManagementService, private languageManagementService: LanguageManagementService, private wsUserService: WsUserService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      success: 'payment_qr_success_' + this.htmlId,
      failed: 'payment_qr_failed_' + this.htmlId,
      customer_name: 'customer_name_' + this.htmlId,
      customer_email: 'customer_email_' + this.htmlId,
      customer_contact: 'customer_contact_' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.name = this.localService.languageContent.common.title;
    this.onCheckWsBusinesEmitDetection();
  }

  ngOnChanges(): void {
    this.paymentLinkUrl = '';
    if (this.isShowPayment && this.interactionType != InteractionType.Bill_PnixSoft) {
      this.isPaymentLink = false;
      this.onLoad();
    } else {
      this.isPaymentLink = true;
      this.localService.onFocusNextInput(this.elementIds.customer_name, FocusInputType.TextBox, true);
    }
  }

  onSwitchPaymentWindow() {
    this.isPaymentLink = false;
    this.onLoad();
  }

  onLoad() {
    this.paymentLinkUrl = '';
    if (this.isShowTestCallBack && environment.current_environment_name == 'Production') {
      this.isShowTestCallBack = false;
    }
    this.isTriggeredFromTestCallback = false;

    if (this.currency == '')
      this.currency = this.localService.getCurrencyByCountryCode();

    if (this.doCheck()) {
      this.payment = {
        amount: this.amount,
        currrency: this.currency,
        interactionType: this.interactionType ?? this.localService.basicParams.interactionType,
        notes: this.notes,
        businessOrUserId: this.businessOrUserId,
        paidType: this.paidType,
        ids: this.ids,
        datas: this.datas,
        supportingId: this.supportingId,
        isPaymentLink: this.isPaymentLink
      } as Payment;

      this.paymentManagementService.getOrderId(this.payment, this.currency, this.customerDetails).subscribe(result => {
        let status: Status = parseInt(result.v6);
        switch (status) {
          case Status.Allowed: {
            this.onClose({
              status: status
            });
          } break;
          case Status.Duplicate: {
          } break;
          case Status.Success: {
            const key = this.localService.decryptCrypto(result.key);
            this.paymentGatewayServiceType = parseInt(result.v1);
            this.orderId = result.v2;
            this.payment.serviceType = this.paymentGatewayServiceType;
            this.payment.orderId = this.orderId;
            this.processId = result.v5;

            if (this.isPaymentLink) {
              this.paymentLinkUrl = result.v8;
            } else {
              switch (this.paymentGatewayServiceType) {
                case PaymentGatewayServiceType.RazorPay: {
                  this.payWithRazor(key);
                } break;
              }
            }

          } break;
          case Status.MinimumRequired: {
            if (this.localService.languageContent.payments) {
              let message = this.localService.languageContent.payments.minimum_req;
              message = message.replace("#var1#", result.v7);
              this.localService.showMessage(message);
            }
          } break;
          case Status.UnAvailable: {
            const message = this.localService.languageContent.payments.payment_unavailable;
            this.localService.showMessage(message);
            this.onClose();
          } break;
          default: {
            this.localService.showInformationByStatus(status, true);
          } break;
        }
      });

    } else {
      this.onClose();
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onUpdateStatus(true);
      } break;
      case 2: {
        this.onUpdateStatus(false);
      } break;
    }
  }


  onClose(emitMessage: any = null) {
    this.orderId = '';
    this.processId = '';
    this.isShowPayment = false;
    this.isShowPaymentChange.emit(emitMessage);
    if (this.isShowTestCallBack && this.isTriggeredFromTestCallback) {
      const closeButtons = document.getElementsByClassName('razorpay-container');
      if (closeButtons && closeButtons.length > 0) {
        const closeButton = closeButtons[0] as HTMLElement;
        closeButton.style.display = 'none';
      }
    }
  }

  isTriggeredFromTestCallback = false;
  onUpdateStatus(isSuccess: boolean) {
    this.isTriggeredFromTestCallback = true;
    const orderStatus = isSuccess ? PaymentGatewayOrderStatus.Success : PaymentGatewayOrderStatus.Failed;
    this.paymentManagementService.updatePaymentGatewayResponse(CallbackType.Order, this.processId, orderStatus, this.businessOrUserId).subscribe(result => {
    });
  }

  onCheckWsBusinesEmitDetection() {
    this.wsUserService.onEmitDetected(RegisterName.BusinessEmitDetected).subscribe((res: EmitResponse) => {
      switch (res.emitType) {
        case EmitType.PaymentProccesed: {
          const paymentStatus: PaymentGatewayOrderStatus = res.result.status;
          if (res.result.processId == this.processId) {
            const status = paymentStatus == PaymentGatewayOrderStatus.Success ? Status.Success : Status.Failed;
            this.onPaymentProccesed.emit(status);
            this.localService.showInformationByStatus(status);
            this.onClose();
          }
        } break;
      }
    });
  }

  payWithRazor(key_id: string) {
    const options: any = {
      key: key_id,
      name: this.name, // company name or product name
      description: '',  // product description
      image: this.logoUrl, // company logo or product image
      order_id: this.orderId, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        note: this.notes
      },
      theme: {
        color: '#008CBA'
      }
    };
    options.handler = ((response, error) => {
      this.onClose();
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      this.onClose();
      // handle the case when user closes the form while transaction is in progress
      //console.log('Transaction cancelled.');
    });
    this.razorpayWindow = new this.winRef.nativeWindow.Razorpay(options);
    this.razorpayWindow.open();
  }

  doCheck(): boolean {
    let msg = '';

    if (!this.amount) {
      msg = this.localService.languageContent.common.amount_required;
    } else if (this.amount < 1) {
      msg = this.localService.languageContent.common.min_1_amount_required;
    } else if (this.businessOrUserId == '') {
      msg = this.localService.languageContent.common.biz_user_id_required;
    }

    if (msg != '') {
      this.localService.showInformation(msg, true);
    }
    return msg == '';
  }
}
